module.exports = __webpack_public_path__ + "assets/cambridge_university_logo.7a6d3637e5c797cd2e49d2ed5ce219be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cambridge_university_logo.png
// module id = 77
// module chunks = 0